var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "supply-dialog",
      attrs: {
        visible: _vm.supplyDialogVisible,
        "close-on-click-modal": false,
        width: "680px"
      },
      on: {
        "update:visible": function($event) {
          _vm.supplyDialogVisible = $event
        },
        close: _vm.handleSupplyDialogClose
      }
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.isEdit ? "编辑档口档案" : "新建档口"))
        ]),
        _vm._v(" "),
        _vm.isEdit && _vm.editDisabled
          ? _c("div", { staticClass: "edit-tip" }, [
              _vm._v("\n      置灰字段，请在ys-档口黄页进行修改\n    ")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "supplyFormRef",
          attrs: {
            "label-width": "140px",
            rules: _vm.rules,
            model: _vm.supplyForm
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "品牌名(APP内展示)", prop: "brand_name" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入一手商城档口名，在App内展示（20个字）",
                  maxlength: 20,
                  disabled: _vm.editDisabled
                },
                model: {
                  value: _vm.supplyForm.brand_name,
                  callback: function($$v) {
                    _vm.$set(_vm.supplyForm, "brand_name", $$v)
                  },
                  expression: "supplyForm.brand_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "alias_brand_name" } },
            [
              _vm.supplyForm.alias_brand_name.length < 4
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.addAliasBrandName }
                    },
                    [_vm._v("\n        增加品牌别名\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.supplyForm.alias_brand_name, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: { display: "flex", "margin-bottom": "20px" }
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: 20, placeholder: "请输入别名" },
                      model: {
                        value: _vm.supplyForm.alias_brand_name[index],
                        callback: function($$v) {
                          _vm.$set(_vm.supplyForm.alias_brand_name, index, $$v)
                        },
                        expression: "supplyForm.alias_brand_name[index]"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.delAliasBrandName(index)
                          }
                        }
                      },
                      [_vm._v("\n          删除\n        ")]
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "城市", prop: "city" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "城市",
                    disabled: _vm.editDisabled
                  },
                  on: { change: _vm.handleSelectCity },
                  model: {
                    value: _vm.supplyForm.city,
                    callback: function($$v) {
                      _vm.$set(_vm.supplyForm, "city", $$v)
                    },
                    expression: "supplyForm.city"
                  }
                },
                _vm._l(_vm.cityList, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "市场", prop: "first_market_id" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "市场",
                    disabled: _vm.editDisabled
                  },
                  on: { change: _vm.setChild },
                  model: {
                    value: _vm.supplyForm.first_market_id,
                    callback: function($$v) {
                      _vm.$set(_vm.supplyForm, "first_market_id", $$v)
                    },
                    expression: "supplyForm.first_market_id"
                  }
                },
                _vm._l(_vm.marketList, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "子市场", prop: "market_id" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "子市场",
                    disabled: _vm.editDisabled
                  },
                  model: {
                    value: _vm.supplyForm.market_id,
                    callback: function($$v) {
                      _vm.$set(_vm.supplyForm, "market_id", $$v)
                    },
                    expression: "supplyForm.market_id"
                  }
                },
                _vm._l(_vm.subMarketList, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否可提前订阅", prop: "show_app" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.supplyForm.show_app,
                    callback: function($$v) {
                      _vm.$set(_vm.supplyForm, "show_app", $$v)
                    },
                    expression: "supplyForm.show_app"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("可提前订阅")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("不可提前订阅")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "楼层", prop: "floor" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "楼层",
                    disabled: _vm.editDisabled
                  },
                  model: {
                    value: _vm.supplyForm.floor,
                    callback: function($$v) {
                      _vm.$set(_vm.supplyForm, "floor", $$v)
                    },
                    expression: "supplyForm.floor"
                  }
                },
                _vm._l(_vm.floorList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "区域/街", prop: "area_id" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "区域/街",
                    disabled: _vm.editDisabled
                  },
                  model: {
                    value: _vm.supplyForm.area_id,
                    callback: function($$v) {
                      _vm.$set(_vm.supplyForm, "area_id", $$v)
                    },
                    expression: "supplyForm.area_id"
                  }
                },
                _vm._l(_vm.areaList, function(item) {
                  return _c("el-option", {
                    key: item.supply_area_id,
                    attrs: {
                      label: item.supply_area,
                      value: item.supply_area_id
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "档口号" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "档口门牌等信息（最长 20个字符）",
                  disabled: _vm.editDisabled,
                  maxlength: 20
                },
                model: {
                  value: _vm.supplyForm.supplier_num,
                  callback: function($$v) {
                    _vm.$set(_vm.supplyForm, "supplier_num", $$v)
                  },
                  expression: "supplyForm.supplier_num"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { label: "档口logo(填写后，在App内展示）", prop: "avatar" }
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: _vm.action,
                    "show-file-list": false,
                    "on-success": _vm.uploadSuccess,
                    "before-upload": _vm.uploadBefore,
                    accept: "image/*",
                    "with-credentials": ""
                  }
                },
                [
                  _vm.supplyForm.avatar
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.supplyForm.avatar }
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon"
                      })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "档口简介(填写后，在App内展示）",
                prop: "description"
              }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "请输入档口简介，若填写，将在app内展示"
                },
                model: {
                  value: _vm.supplyForm.description,
                  callback: function($$v) {
                    _vm.$set(_vm.supplyForm, "description", $$v)
                  },
                  expression: "supplyForm.description"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.supplyDialogVisible = false
                    }
                  }
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.isEdit ? "保存" : "确认新增") +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ff6611b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff6611b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplyapply/components/SupplyMessageDialog.vue
// module id = null
// module chunks = 